import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=4b6102b2&scoped=true&"
import script from "./Element.vue?vue&type=script&lang=js&"
export * from "./Element.vue?vue&type=script&lang=js&"
import style0 from "./Element.vue?vue&type=style&index=0&id=4b6102b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6102b2",
  null
  
)

export default component.exports